import { QueryParser } from "./QueryParser";
import { RouteWithParent } from "./RouteWithParent";
const RouteMatcherLib = require('route-parser');
export class RouteMatcher extends RouteWithParent {
    /**
     * @param _options
     * @param _parent
     */
    constructor(_options, _parent) {
        super(_options, _parent);
        this._options = _options;
        this._parent = _parent;
        this.matcher = new RouteMatcherLib(_options.path);
    }
    /**
     * @param path
     * @return {any}
     */
    match(path) {
        let params = this.matcher.match(path);
        if (!params) {
            return false;
        }
        return params;
    }
    /**
     * @param params
     * @param query
     * @return {string}
     */
    buildUrl(params, query) {
        return this.matcher.reverse(params) + (query ? QueryParser.toString(query) : "");
    }
}
